/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPaymentStatus } from './ControlPaymentStatus';
import {
    ControlPaymentStatusFromJSON,
    ControlPaymentStatusFromJSONTyped,
    ControlPaymentStatusToJSON,
} from './ControlPaymentStatus';

/**
 * 
 * @export
 * @interface ControlSecurityProductItem
 */
export interface ControlSecurityProductItem {
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    product_type: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    security_sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    presented_price?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    price_target_currency?: ControlSecurityProductItemPriceTargetCurrencyEnum;
    /**
     * 
     * @type {ControlPaymentStatus}
     * @memberof ControlSecurityProductItem
     */
    payment_status: ControlPaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    broker_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityProductItem
     */
    agency_id?: string;
}


/**
 * @export
 */
export const ControlSecurityProductItemPriceTargetCurrencyEnum = {
    Usd: 'usd',
    Cad: 'cad'
} as const;
export type ControlSecurityProductItemPriceTargetCurrencyEnum = typeof ControlSecurityProductItemPriceTargetCurrencyEnum[keyof typeof ControlSecurityProductItemPriceTargetCurrencyEnum];


/**
 * Check if a given object implements the ControlSecurityProductItem interface.
 */
export function instanceOfControlSecurityProductItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "policy_id" in value;
    isInstance = isInstance && "product_type" in value;
    isInstance = isInstance && "payment_status" in value;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlSecurityProductItemFromJSON(json: any): ControlSecurityProductItem {
    return ControlSecurityProductItemFromJSONTyped(json, false);
}

export function ControlSecurityProductItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSecurityProductItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'policy_id': json['policy_id'],
        'product_type': json['product_type'],
        'security_sku': !exists(json, 'security_sku') ? undefined : json['security_sku'],
        'presented_price': !exists(json, 'presented_price') ? undefined : json['presented_price'],
        'price_target_currency': !exists(json, 'price_target_currency') ? undefined : json['price_target_currency'],
        'payment_status': ControlPaymentStatusFromJSON(json['payment_status']),
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'broker_id': !exists(json, 'broker_id') ? undefined : json['broker_id'],
        'agency_id': !exists(json, 'agency_id') ? undefined : json['agency_id'],
    };
}

export function ControlSecurityProductItemToJSON(value?: ControlSecurityProductItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'policy_id': value.policy_id,
        'product_type': value.product_type,
        'security_sku': value.security_sku,
        'presented_price': value.presented_price,
        'price_target_currency': value.price_target_currency,
        'payment_status': ControlPaymentStatusToJSON(value.payment_status),
        'client_id': value.client_id,
        'org_id': value.org_id,
        'broker_id': value.broker_id,
        'agency_id': value.agency_id,
    };
}

